import React from "react";

interface StringLinkCellProps {
  value: string | { label?: string } | null | undefined;
  [key: string]: any;
}

/**
 * Blue, link-styled text cell (e.g. the Tasks worklist "Task" column).
 *
 * Renders the value as a clickable-looking link (oasis `table-cell-btn__link`).
 * The click itself is handled at the row level in `handleRowClickAction` (routed
 * by the cell's `<type>__<header>` class), so this component is presentation-only.
 */
export const StringLinkCell: React.FC<StringLinkCellProps> = ({ value }) => {
  const text =
    typeof value === "object" && value !== null ? (value.label ?? "") : value;
  return (
    <div title={String(text ?? "")} className="table-cell-btn__link truncate">
      {text}
    </div>
  );
};

export default StringLinkCell;
